import { defineRule } from 'vee-validate'

defineRule('phoneNumberWithoutCountryCode', (value, target) => {
  return (
    (value !== null && (target[0] !== '' || target[0] !== null)) ||
    (value === null && (target[0] === '' || target[0] === null))
  )
})
